import React from 'react';

import styled from 'styled-components';

import { useCommunityInfoContext } from './CommunityInfoContext';
import CommunityInfoHeaderBreadcrumbs from './CommunityInfoHeaderBreadcrumbs';
import { canShowCommunityInfoPricingData } from './utils';
import SnapshotControls from '../../common/Snapshot/SnapshotControls';
import { useAppSelector } from '../../store/hook';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 10px 30px;
`;

const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
  white-space: nowrap;
`;

const TitleContainer = styled.div`
  display: flex;
  gap: 10px;
`;

const TitleIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background-color: var(--positive-green);
  border-radius: 10px;
  box-shadow: 0 2px 4px 0 var(--box-shadow-pink);
`;

const Title = styled.span`
  font-family: var(--font-bold);
  font-size: 40px;
`;

const CommunityInfoHeader = () => {
  const { isCompetitor, mode } = useCommunityInfoContext();
  const { currentUser } = useAppSelector((state) => state.auth);
  const showPricingData = canShowCommunityInfoPricingData(currentUser, mode);
  return (
    <Container data-test-id="cd-community-info-header">
      <HeaderContent data-test-id="cd-community-info-header-content">
        <CommunityInfoHeaderBreadcrumbs />
        <TitleContainer data-test-id="cd-community-info-header-title-container">
          <TitleIcon data-test-id="cd-community-info-header-title-icon">
            <img
              src={'/icons/checklist-white.svg'}
              alt="CommunityInfo"
              style={{
                width: 24,
                height: 24,
              }}
            />
          </TitleIcon>
          <Title data-test-id="cd-title">{isCompetitor ? 'Competitor Data' : 'Community Data'}</Title>
        </TitleContainer>
      </HeaderContent>
      {showPricingData && <SnapshotControls />}
    </Container>
  );
};

export default CommunityInfoHeader;
